import { render, staticRenderFns } from "./bottomnav2.vue?vue&type=template&id=93cc9768&scoped=true&"
import script from "./bottomnav2.vue?vue&type=script&lang=js&"
export * from "./bottomnav2.vue?vue&type=script&lang=js&"
import style0 from "./bottomnav2.vue?vue&type=style&index=0&id=93cc9768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93cc9768",
  null
  
)

export default component.exports